"use strict";
import React, { Suspense, useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import i18nInstance from 'jsAssets/lang/i18n.ts';
import { PulseUploaderDropzone } from '@pcs/pulse-components';
import utilities, { jsRequest, webpackPublicPath } from '../utilities';
import { EVENT_CLICK_SHOW_MODAL_REQUEST_FORM } from '../../components/support/brand-product-request/helper';

__webpack_public_path__ = webpackPublicPath();

const BrandProductRequest = React.lazy(() =>
  import('../../components/support/brand-product-request')
);

const GET_ASSETS_VALUE = 'getAssetsValues';

const FileUploader = () => {
    const [assets, setAssets] = useState([]);

    useEffect(() => {
        const event = new CustomEvent(GET_ASSETS_VALUE, { detail: assets });
        document.dispatchEvent(event);
    }, [assets]);

    return (
        <PulseUploaderDropzone 
            allowSelectFolder={false}
            files={assets}
            isMultiple
            onFileDrop={(files) => {
                setAssets([...assets, ...files]);
            }}
            onFileRename={(files) => {
                setAssets([...files]);
            }}
            onFileRemove={(file, positionFile = 0) => {
                setAssets(assets.filter((asset, index) => index !== positionFile));
            }}
            visible={true}
        />
    )
}

// const { config } = window.pulse;
export default class Support {

    constructor() {
        this.isBrandProductRequestComponentMounted = false;
    }

    validateGeneralSupportRequiredFields(form) {
        let validated = true;
        utilities.dismissNotifications();

        $("#pulse-support-form .required-field").each(function () {
            $(this).removeClass("uk-form-danger");
        });


        $("#" + form + " .required-field").each(function () {
            if (!$(this).val()) {
                $(this).addClass("uk-form-danger");
                validated = false;
            }
        });

        if (!validated) {
            utilities.notify({
                message: 'Please fill in the required fields',
                status: 'danger',
                timeout: 4000,
                pos: 'top-center'
            });
        }

        let name = $("#" + form + " input[name='name']").val();

        if (/\d/.test(name)) {
            utilities.notify({
                message: 'Please enter a valid name',
                status: 'danger',
                timeout: 4000,
                pos: 'top-center'
            });

            $("#" + form + " input[name='name']").addClass("uk-form-danger");

            validated = false;
        }

        let regex = /^([a-zA-Z0-9_.+-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;

        if (!regex.test($("#" + form + " input[name='email']").val())) {
            utilities.notify({
                message: 'Please enter a valid email address',
                status: 'danger',
                timeout: 4000,
                pos: 'top-center'
            });

            $("#" + form + " input[name='email']").addClass("uk-form-danger");

            validated = false;
        }

        return validated;
    }

    validateNewUserRequiredFields() {
        let validated = true;
        utilities.dismissNotifications();

        $("#new-user-request input, #new-user-request select, #new-user-request textarea").each(function () {
            $(this).removeClass("uk-form-danger");
        });

        $("#new-user-request .required-field").each(function () {
            if (!$(this).val()) {
                $(this).addClass("uk-form-danger");
                validated = false;
            } else if ($(this).attr("name") == "nclientid" && $(this).val() == 0) {
                $(this).addClass("uk-form-danger");
                validated = false;
            }
        });

        if (!validated) {
            utilities.notify({
                message: 'Please fill in the required fields',
                status: 'danger',
                timeout: 4000,
                pos: 'top-center'
            });
        }

        let name = $("input[name='name']").val();

        if (/\d/.test(name)) {
            utilities.notify({
                message: 'Please enter a valid name',
                status: 'danger',
                timeout: 4000,
                pos: 'top-center'
            });

            $("input[name='name']").addClass("uk-form-danger");

            validated = false;
        }

        let regex = /^([a-zA-Z0-9_.+-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;

        if (!regex.test($("input[name='email']").val())) {
            utilities.notify({
                message: 'Please enter a valid email address',
                status: 'danger',
                timeout: 4000,
                pos: 'top-center'
            });

            $("input[name='email']").addClass("uk-form-danger");

            validated = false;
        }

        let phone = $("input[name='phone']").val();
        if (phone && isNaN(phone)) {
            utilities.notify({
                message: 'Please enter a valid phone number',
                status: 'danger',
                timeout: 4000,
                pos: 'top-center'
            });

            $("input[name='phone']").addClass("uk-form-danger");

            validated = false;
        }

        let mobile = $("input[name='mobile']").val();
        if (mobile && isNaN(mobile)) {
            utilities.notify({
                message: 'Please enter a valid mobile number',
                status: 'danger',
                timeout: 4000,
                pos: 'top-center'
            });

            $("input[name='mobile']").addClass("uk-form-danger");

            validated = false;
        }

        return validated;
    }

    success() {
        utilities.unblockPage();
        utilities.notify({
            message: 'Your support request has been submitted and we will respond to you shortly ...',
            status: 'info',
            timeout: 4000,
            pos: 'top-center'
        });
    }

    applyBindings() {
        let self = this;
        const { isOpenBrandRequestForm = false, permission = {} } = jsRequest || {};

        const uploaderCtn = document.querySelector('#file-uploader');
        let assets = [];
        if (uploaderCtn) {
            document.addEventListener(GET_ASSETS_VALUE, (event) => {
                assets = event.detail;
            });
            const uploadRoot = createRoot(uploaderCtn);
            uploadRoot.render(<FileUploader />);
        }

        if (isOpenBrandRequestForm && permission?.manageProjects === 'y') { 
            this.renderBrandProductRequestForm();
        }

        $("[type='back']").on("click", function (e) {
            e.preventDefault();
            window.history.back();
        });

        $("#pulse-support-form button[type='submit']").on("click", function (e) {
            e.preventDefault();
            document.removeEventListener(GET_ASSETS_VALUE, (event) => {
                assets = event.detail;
            });

            let form = $(this).attr('data-target');
            let name, email, subject, message;
            $(this).closest('form').serializeArray().map((field) => {
                switch (field.name) {
                    case 'name':
                        name = field.value;
                        break;
                    case 'email':
                        email = field.value;
                        break;
                    case 'subject':
                        subject = field.value;
                        break;
                    case 'message':
                        message = field.value;
                        break;
                    default:
                        break;
                }
            });

            if (form) {
                if (self.validateGeneralSupportRequiredFields(form)) {
                    const formData = new FormData();
                    formData.set('name', name);
                    formData.set('email', email);
                    formData.set('subject', subject);
                    formData.set('message', message);
                    assets.forEach((asset, index) => {
                        formData.append(`attachments[${index}]`, asset);
                    });
                    
                    utilities.blockPage("Submitting support request...");
                    $.ajax({
                        url: window.pulse.config.urls.pulse + "ajax.php?action=support&type=" + form,
                        method: "POST",
                        dataType: "json",
                        data: formData,
                        processData: false,
                        contentType: false,
                    }).done(function (response) {
                        if (response.status == "success") {
                            let userLoggedIn = false;
                            if (typeof response.data != 'undefined') {
                                userLoggedIn = response.data.user_logged_in;
                            }
                            self.success(userLoggedIn, form);
                            setTimeout(function () {
                                window.location.href = window.pulse.config.urls.app + 'support/general';
                            }, 2000);
                        } else {
                            utilities.unblockPage();
                            utilities.notify({
                                message: response.message,
                                status: 'danger',
                                timeout: 4000,
                                pos: 'top-center'
                            });
                        }
                    }).fail(function () {
                        utilities.unblockPage();
                    });
                }
            } else {
                utilities.notify({
                    message: 'The form is not available and can not be validated.',
                    status: 'danger',
                    timeout: 4000,
                    pos: 'top-center'
                });
                return false;
            }
        });

        $("#new-user-request button[type='submit']").on("click", function (e) {
            e.preventDefault();

            if (self.validateNewUserRequiredFields()) {
                let inputData = {};
                $.each($('#new-user-request').serializeArray(), function () {
                    inputData[this.name] = this.value;
                });

                utilities.blockPage("Submitting new user request...");
                $.ajax({
                    url: window.pulse.config.urls.pulse + "ajax.php?action=support&type=new-user",
                    method: "POST",
                    dataType: "json",
                    data: inputData
                }).done(function (response) {
                    if (response.success == true) {
                        self.success();
                        window.location.href = window.pulse.config.urls.app + 'login';
                    } else {
                        utilities.unblockPage();
                        utilities.notify({
                            message: response.message,
                            status: 'danger',
                            timeout: 4000,
                            pos: 'top-center'
                        });
                    }
                }).fail(function () {
                    utilities.unblockPage();
                });
            }
        });

        $("#brand-access-support").on("click", function() {
            if (!self.isBrandProductRequestComponentMounted) {
                self.renderBrandProductRequestForm();
            } else {
                const eventClickShowModalRequestForm = new CustomEvent(
                    EVENT_CLICK_SHOW_MODAL_REQUEST_FORM
                );
                window.dispatchEvent(eventClickShowModalRequestForm);
            }
        });

        let area = window.location.href;
        area = area.match(/(\w+)$/g);
        if ($.isArray(area) && area[0] == 'frozen') {
            $('li').removeClass('uk-active');
            $('#frozen').addClass('uk-active');
            $('form').removeClass('uk-active');
            $('#frozen-account').addClass('uk-active');
        }
    }

    init() {
        this.applyBindings();
    }

    renderBrandProductRequestForm() {
        utilities.blockPage();
        const brandProductRequestCtn = document.querySelector(
            '#brand-access-support-modal'
        );
        const brandProductRequestRoot = brandProductRequestCtn && createRoot(brandProductRequestCtn);
        brandProductRequestRoot.render(
            <I18nextProvider i18n={i18nInstance}>
                <Suspense fallback={<></>}>
                    <BrandProductRequest />
                </Suspense>
            </I18nextProvider>
        );
        this.isBrandProductRequestComponentMounted = true;
    }
}

(function ($) {
    $(function () {
        let support = new Support();
        support.init();
    });
})(jQuery);